import getCdnUrl from '../../helpers/get-cdn-url';

const RateEquation = getCdnUrl('/common_assets/rate_equation.webp');

export default RateEquation;
